import React, {ComponentProps, ReactElement} from 'react';
import {EzChip, EzPageHeader} from '@ezcater/recipe';
import {useTranslation} from 'react-i18next';
import {OrderSourceType} from './OrderStatusBadge/OrderStatusBadge';
import OrderSourceTypeBadge from './OrderSourceTypeBadge';

interface Props
  extends Pick<
    ComponentProps<typeof EzPageHeader>,
    'title' | 'breadcrumb' | 'subheader' | 'subnav'
  > {
  readonly storeSelector?: ReactElement | null;
  readonly actionButtons?: ReactElement | ReactElement[];
  readonly orderSourceType?: OrderSourceType;
  readonly lastUpdated?: string | null;
}

export const dateHelper = (date: string) => {
  return new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export default function TopBar({
  lastUpdated,
  storeSelector,
  title,
  actionButtons,
  breadcrumb,
  orderSourceType,
  subheader,
  subnav,
}: Props) {
  const {t} = useTranslation();

  let status;
  if (orderSourceType) {
    status = <OrderSourceTypeBadge orderSourceType={orderSourceType} />;
  } else if (lastUpdated) {
    status = (
      <EzChip
        label={`${t('components.TopBar.lastUpdated', {lastUpdated: dateHelper(lastUpdated)})}`}
        variant="informational"
        data-testid="last-updated"
      />
    );
  }

  return (
    <EzPageHeader
      title={title}
      status={status}
      breadcrumb={breadcrumb}
      actions={
        <>
          {storeSelector}
          {actionButtons}
        </>
      }
      subheader={subheader}
      subnav={subnav}
    />
  );
}
